import { render, staticRenderFns } from "./children-educationHome.vue?vue&type=template&id=335bae14&scoped=true&"
import script from "./children-educationHome.vue?vue&type=script&lang=js&"
export * from "./children-educationHome.vue?vue&type=script&lang=js&"
import style0 from "./children-educationHome.vue?vue&type=style&index=0&id=335bae14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "335bae14",
  null
  
)

export default component.exports